jQuery( document ).ready(function($) {
  $( ".product__accordion" ).wrapAll( "<div class='new' />");
  //$( ".product-customproduct .onlycostomproduct" ).prepend( "<div class='test'></div>");
  $('#shopify-block-subscriptions_app_block_RMaQjF').addClass('wapperSection');
  $('#rbz-zipcode-check-section').addClass('wapperSection');
  $( ".wapperSection" ).wrapAll( "<div class='commonSection' />");
  $('.product-customproduct .onlycostomproduct').addClass('wapperSection01');
  $('.product-customproduct .new').addClass('wapperSection01');
  $( ".wapperSection01" ).wrapAll( "<div class='commonSectionLatest' />");
  $( ".commonSection" ).wrapAll( "<div class='commonSectionMain' />");
  $(".product-customproduct .commonSectionMain").prepend("<div class='subscribeOption'><div class='iconOptions'>▼</div><span>Subscribe Options</span></div>");
  $(document).on('click','.product-customproduct .subscribeOption', function() {
    //$('.product-customproduct .commonSection').slideToggle('slow');
  });

  $('.appstle_manageSubBtn').parents('body').addClass('papa');

    $('html').find('.zipcode_checkout_btn_info').addClass('strike');
  

$('.subscriptionUser').parents('body').addClass('siteuser');

  setInterval(function(){
      var els = document.querySelectorAll("html .zipcode_checkout_btn_info");
      var body = document.querySelector("body");
    
      if (els.length > 1) {
        body.classList.add("onlyPostcode");
        body.classList.remove("allPostcode");
      } else {
        body.classList.add("allPostcode");
        body.classList.remove("onlyPostcode");
      }
    
    var zip = $('#check_zipcode').text();
    if (zip == 0) {
        $('body').addClass('zip-code');
    } else {
        $('body').removeClass('zip-code');
    }
}, 1000);

  
    /*let dateElementjQuery = $('.as-tab-content-wrapper').find('.as-tab-content').find('.as-items-start').find('.as-panel-right').find('.as-edit-billing').find('.as-edit-billing_info').find('h3.as-text-sm');
    //let dateElement = document.querySelector(".as-tab-content-wrapper .as-edit-billing_info").querySelectorAll("h3.as-text-sm");
    //let dateElement = document.querySelectorAll(".as-tab-content-wrapper .as-edit-billing_info").children;
    console.log('here prints Jquery');
    console.log(dateElementjQuery);*/

  
 
});




jQuery(window).on('load', function($){
    setTimeout(function() {
      checkDates();
    }, 1500);
});

function startTime() {
  const date = new Date();
  let dateElement = document.querySelectorAll('.as-tab-content-wrapper  .as-edit-billing_info h3.as-text-sm').innerHTML = date.toLocaleTimeString();
  console.log(dateElement);
  setTimeout(function() {startTime()}, 1000);
}

startTime();

function checkDates(){
  //alert('inserted');
  var mainElement = document.getElementsByClassName("as-edit-billing_data");
  // let subEle = mainElement.innerHTML;
  // let headingEle = mainElement.querySelectorAll('h3.as-text-s');
  //let dateElement = document.querySelector(".as-tab-content-wrapper .as-edit-billing_info").querySelectorAll("h3.as-text-sm");
  //let dateElement = document.querySelectorAll(".as-tab-content-wrapper .as-edit-billing_info").children;
  console.log('here prints timeout');
  console.log(mainElement); // [...mainElement].forEach(x => console.log(x.innerHTML))
  var headingInnerText = '';
  console.log(mainElement.length);
  var i = 0;
  while(i < mainElement.length){
    console.log(mainElement[i].innerHTML);
    console.log(mainElement[i].innerText);
    headingInnerText = mainElement[i].innerText;
    i++;
  }
    
  // console.log(headingInnerText);
  console.log([...mainElement]);
}



//setTimeout(function() {
  
//}, 1500);

  // let dateElement = document.querySelectorAll('.as-tab-content-wrapper .as-tab-content .as-items-start .as-panel-right .as-edit-billing .as-edit-billing_info h3.as-text-sm');
  